import React from 'react'

import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';

import { icons } from "constants/icons";

const DialogTitleWithClose: React.FC<{
  onModalClose: () => void;
  title: string;
}> = (props) => {
  return (
    <DialogTitle style={{ fontSize: '16px' }}>
      <Grid container justifyContent="space-between">
        {props.title}
        <img
          src={icons.modalClose}
          alt="close"
          aria-hidden="true"
          className="cursor-pointer"
          onClick={props.onModalClose}
        />
      </Grid>
    </DialogTitle>
  )
}

export default DialogTitleWithClose;
